import { useLang, STR } from "@/i18n";

export default function Marquee() {
  const { lang } = useLang();
  const row = [...STR[lang].marquee, ...STR[lang].marquee];
  return (
    <section
      data-testid="editorial-marquee"
      className="relative py-6 border-y border-white/10 bg-gradient-to-r from-blue-600/10 via-amber-500/10 to-blue-600/10 overflow-hidden"
      aria-hidden="true"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-bold text-lg sm:text-2xl tracking-wide text-white/80 px-6">
                  {item}
                </span>
                <span className={`w-2 h-2 rotate-45 ${
                  i % 3 === 0 ? "bg-sky-400" : i % 3 === 1 ? "bg-amber-400" : "bg-white"
                }`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
